// undefined = source data not fetched yet; a configured filter must not match a guessed value
export interface BannerConsumerState {
    isDeviceRegistered: boolean | undefined;
    isLoyaltyMember: boolean | undefined;
    isClubPlusSubscriber: boolean | undefined;
}

const matchesState = (configuredState: string | undefined, consumerState: boolean | undefined) =>
    !configuredState || (consumerState !== undefined && configuredState === String(consumerState));

export const isBannerEnabled = (banner: any, consumerState: BannerConsumerState) => {
    if (!banner) return false;

    const {deviceRegistrationState, loyaltyMemberState, clubPlusSubscriptionState} = banner;

    return (
        matchesState(deviceRegistrationState, consumerState.isDeviceRegistered) &&
        matchesState(loyaltyMemberState, consumerState.isLoyaltyMember) &&
        matchesState(clubPlusSubscriptionState, consumerState.isClubPlusSubscriber)
    );
};
